import React from "react";
import styled from "styled-components";

interface HexagonButtonProps {
  label: string;
  width?: number;
}

const Wrapper = styled.div<{ width: number }>`
  width: ${({ width }) => width}px;
  height: 100px;
  position: relative;
  cursor: pointer;
`;

const ScaledSVG = styled.svg`
  width: 100%;
  height: 100%;

  polygon {
    fill: ${({ theme }) => theme.colors.background};
    stroke: ${({ theme }) => theme.colors.primary};
    stroke-width: 4;
    transition: all 0.3s ease;
  }

  ${Wrapper}:hover & polygon {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

const Label = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: 700;
  font-size: 1rem;
  pointer-events: none;

  ${Wrapper}:hover & {
    color: ${({ theme }) => theme.colors.background};
  }
`;

export const ArtDecoButton: React.FC<HexagonButtonProps> = ({
  label,
  width = 200,
}) => {
  return (
    <Wrapper width={width}>
      <ScaledSVG viewBox="0 0 100 100" preserveAspectRatio="none">
        <polygon points="20,0 80,0 100,50 80,100 20,100 0,50" />
      </ScaledSVG>
      <Label>{label}</Label>
    </Wrapper>
  );
};